import type { InvoiceOverview } from '@weft/api-definition';
import React from 'react';
import type { VyTableMinimalProps } from '../../../../../../components/new-design/table/vy-table/VyTable';
import { VyTable } from '../../../../../../components/new-design/table/vy-table/VyTable';
import { SYNC_INVOICES_COLUMNS } from '../sync-invoices-dialog-consts/sync-invoices-columns';

export const SyncInvoicesTable: React.FC<VyTableMinimalProps<InvoiceOverview>> = ({ items, itemsCount }) => {
  return (
    <div className="flex h-full w-full flex-col">
      <VyTable
        itemsCount={itemsCount}
        items={items}
        columns={SYNC_INVOICES_COLUMNS}
        showPagination={false}
        sx={{
          marginBottom: '30px',
        }}
      />
    </div>
  );
};